import React from "react";

const LocationPin = ({ color, centerColor, content, textColor, ...rest }) => {
  return (
    <div className="h-10 w-10 relative" {...rest}>
      <svg
        width="48px"
        height="50px"
        viewBox="0 0 380 512"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M190 0C85.1 0 0 85.1 0 190C0 294.9 190 512 190 512C190 512 380 294.9 380 190C380 85.1 294.9 0 190 0Z"
          fill={color ? color : "#0AD041"}
        />

        <path
          d="M190 287C137.5 287 95 244.5 95 192C95 139.5 137.5 97 190 97C242.5 97 285 139.5 285 192C285 244.5 242.5 287 190 287Z"
          fill={centerColor ? centerColor : "white"}
        />
      </svg>
      <span className="text-gray-800 font-semibold text-[13px] absolute top-[18px] left-1/2 transform -translate-x-1/2 -translate-y-1/2">
        {content}
      </span>
    </div>
  );
};

export default LocationPin;
